import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=cb96a2dc&scoped=true&lang=pug&"
import script from "./VInput.vue?vue&type=script&lang=js&"
export * from "./VInput.vue?vue&type=script&lang=js&"
import style0 from "./VInput.vue?vue&type=style&index=0&id=cb96a2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb96a2dc",
  null
  
)

export default component.exports